export default {
      id: "arrow-down-usage",
      viewBox: "0 0 53 53",
      url: "../../assets/" + "sprite.svg#arrow-down-usage",
      toString: function () {
        return this.url;
      }
    }